<app-header></app-header>

<div class="container-fluid bg-primary py-5 bg-header mrb-90">
    <div class="row py-5">
        <div class="col-12 pt-lg-5 mt-lg-5 text-center">
            <h1 class="display-4 text-white">Our Team</h1>
            <a routerLink="/" class="h5 text-white">Home</a>
            <i class="far fa-circle text-white px-2"></i>
            <a routerLink="/our-team" class="h5 text-white">Our Team</a>
        </div>
    </div>
</div>

<!-- Team Start -->
<div class="container-fluid py-5">
  <div class="container py-5">

    <div class="section-title text-center position-relative pb-3 mb-5 mx-auto" style="max-width: 600px;">
      <h5 class="fw-bold text-primary text-uppercase">Team Members</h5>
      <h1 class="mb-0">Meet the Creative Minds Behind Our Success</h1>
    </div>

    <div class="row g-5">

      <div class="col-lg-4" *ngFor="let member of teamMembers; let i = index" [attr.data-wow-delay]="(i+1)*0.3 + 's'">

        <div class="team-item bg-light border-radius overflow-hidden">

          <div class="team-img position-relative overflow-hidden">

            <img class="img-fluid w-100"
                 [src]="'assets/images/' + member.image"
                 [alt]="member.name">

            <div class="team-social">

              <a *ngFor="let social of member.socials"
                 class="btn btn-lg btn-primary btn-lg-square border-radius"
                 [href]="social.link">

                <i [class]="social.icon + ' fw-normal'"></i>

              </a>

            </div>

          </div>

          <div class="text-center py-4">
            <h4 class="text-primary">{{member.name}}</h4>
            <p class="text-uppercase m-0">{{member.role}}</p>
          </div>

        </div>

      </div>

    </div>

  </div>
</div>
<!-- Team End -->

<!-- Brands Start -->
<div class="container-fluid">
    <div class="container py-5 mb-5">
        <div class="bg-white">
            <owl-carousel-o [options]="brandsCarousel" class="owl-btn-center-lr vendor-carousel">
                <ng-template carouselSlide *ngFor="let brand of brandStore">
                    <div class="client-box">
                        <a href="#."><img src="assets/images/{{brand.img}}" alt="brand-img"></a>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>
<!-- Brands End -->